import React from 'react';

import { classNames } from '@/shared/helpers';
import userIcon from '@/static/images/user.svg';
import { ILanguage } from '@/interfaces/languages';
import { Languages } from '@/lib/LanguagesIncludingIcons';

import './styles.scss';
import { track } from '@/shared/analytics';

type Props = {
  pathLang: string;
  currentPath: string;
  isMultiLanguage: boolean;
  currentLanguage: ILanguage;
  shouldApplyContrast: boolean;
};

const UserUtils = (props: Props) => {
  const {
    pathLang,
    shouldApplyContrast,
    currentLanguage,
    currentPath,
    isMultiLanguage,
  } = props;

  const getPathWithLang = (lang: string, currentPath: string) => {
    let path = '';

    if (lang !== 'pt-br') {
      path = `${path}/${lang}`;
    }

    if (!currentPath.startsWith('/')) {
      path = path + '/';
    }

    return `${path}${currentPath}`;
  };

  return (
    <section className="user-utils" aria-label="user-info">
      <div
        className={classNames(
          'cart planne-widget planne-widget-cart-preview',
          shouldApplyContrast && 'cart-icon-with-contrast'
        )}
        data-widget-checkout-page="/pagamento/"
      />

      <a href={`/${pathLang}minha-conta`}>
        <div className="user">
          <img
            src={userIcon}
            alt="user-icon"
            className={classNames(shouldApplyContrast && 'image-with-contrast')}
          />
        </div>
      </a>

      {isMultiLanguage ? (
        <div className="languages">
          <div
            role="button"
            className="languagesSwitcher language"
            data-lang={currentLanguage.lang}
          >
            <p>{currentLanguage.lang.toUpperCase()}</p>
            <img
              src={currentLanguage.icon}
              alt={`${currentLanguage.lang} icon`}
            />
          </div>

          <div className="anim-drop-down other-languages">
            {Languages.map((language, index) =>
              language.lang !== currentLanguage.lang ? (
                <a
                  href={getPathWithLang(language.lang, currentPath)}
                  className="anim-drop-down-item language"
                  data-lang={language.lang}
                  onClick={() => {
                    track('languageChange', { template: 'virgoA', language: language.lang });
                  }}
                  key={index}
                >
                  <p>{language.lang.toUpperCase()}</p>
                  <img src={language.icon} alt={`${language.lang} icon`} />
                </a>
              ) : null
            )}
          </div>
        </div>
      ) : null}
    </section>
  );
};

export default UserUtils;
